import cn from 'classnames';
import { Row } from '@tanstack/react-table';

import styles from './ExpanderCell.module.css';

const ExpanderCell = ({ row }: { row: Row<any> }) => (
  <button
    {...{
      type: 'button',
      className: styles.button,
      onClick: row.getToggleExpandedHandler(),
    }}
  >
    <div className={styles.container}>
      <span
        className={cn(styles.icon, {
          [styles.active]: row.getIsExpanded(),
        })}
      />
    </div>
  </button>
);

export default ExpanderCell;
